import { QueryDocumentSnapshot } from 'firebase/firestore'
import FirestoreUser from '../../../../types/FirestoreUser'
import { ReportInfo } from '../../../../types/ReportTypes'
import { fetchUserReportsData } from '../../../../utils/fetchUserReportsData'

/**
 * Fetches report data for an array of user documents
 * Returns ReportInfo for each user including current month status
 *
 * @param docs - Array of user document snapshots
 * @param existingReports - Previously fetched reports (for pagination)
 * @param clear - Whether to clear existing reports
 * @returns Record mapping user IDs to their report information
 */
export async function fetchUserReports(
  docs: QueryDocumentSnapshot<FirestoreUser>[],
  existingReports: Record<string, ReportInfo>,
  clear: boolean
): Promise<Record<string, ReportInfo>> {
  return fetchUserReportsData(docs, existingReports, clear)
}
